import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalBasicsInput,
  terminalBasicsInputSchema,
} from "./shared/terminalBasics.input";
import {
  type TerminalBasic,
  terminalBasicSchema,
} from "./shared/terminalBasics.output";

/**
 * Metadata for the fetchTerminalBasics endpoint
 */
export const terminalBasicsMeta = {
  functionName: "fetchTerminalBasics",
  endpoint: "/terminalBasics",
  inputSchema: terminalBasicsInputSchema,
  outputSchema: terminalBasicSchema.array(),
  sampleParams: {},
  endpointDescription: "List basic information for all terminals.",
} satisfies EndpointMeta<TerminalBasicsInput, TerminalBasic[]>;

const { fetch, useHook } = createFetchAndHook<
  TerminalBasicsInput,
  TerminalBasic[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalBasicsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalBasics.endpoints").terminalBasicsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving basic information for all terminals
 */
export const fetchTerminalBasics: FetchFactory<
  TerminalBasicsInput,
  TerminalBasic[]
> = fetch;

/**
 * React Query hook for retrieving basic information for all terminals
 */
export const useTerminalBasics: HookFactory<
  TerminalBasicsInput,
  TerminalBasic[]
> = useHook;
